import React from 'react';

import PropTypes from 'prop-types';

import Divider from '@adsk/alloy-react-divider';
import { useTheme } from '@adsk/alloy-react-styles';
import { stylePropType, StylableComponent } from '@adsk/alloy-react-theme';

import { BannerVariant, BANNER_VARIANTS } from './consts';

type BannerDividerProps = StylableComponent<HTMLHRElement> & {
  variant?: BannerVariant;
};

const BannerDivider = ({
  style,
  className,
  variant = BANNER_VARIANTS.PRIMARY,
  ...props
}: BannerDividerProps) => {
  const theme = useTheme();
  const dividerTokens = theme.tokens?.component?.banner?.divider;
  const variantTokens = theme.tokens?.component?.banner?.variant?.[variant];

  return (
    <Divider
      variant={Divider.VARIANTS.VERTICAL}
      {...props}
      className={className}
      style={[
        dividerTokens,
        {
          alignSelf: 'center',
          backgroundColor: variantTokens?.divider?.backgroundColor,
        },
        style,
      ]}
    />
  );
};

BannerDivider.displayName = 'BannerDivider';

BannerDivider.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** The banner variant */
  variant: PropTypes.oneOf(Object.values(BANNER_VARIANTS)),
};

export default BannerDivider;
